import { ApiProperty } from '@nestjs/swagger';

export class PusherAuthorizeOutputModel {
  @ApiProperty()
  public readonly auth!: string | null;

  constructor(object: object | null) {
    Object.assign(this, object);
  }
}
